import { useEffect, useState } from "react";

/**
 * Trails `value` by `delayMs`, resetting the timer whenever it changes.
 *
 * Pass a referentially stable value (see `useDeepMemo`) — a fresh object each
 * render restarts the timer every render, so the result never settles.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (delayMs <= 0) {
      setDebouncedValue(value);
      return;
    }
    const timer = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debouncedValue;
}
